<div class="mb-12 flex justify-center items-center flex-col pb-12 mat-typography mt-0 md:mt-3 h-full">
    <div class="bg-gray-300 flex flex-col justify-center items-center md:py-6 md:px-40">
      <mat-spinner
        class="loading-spinner mb-4"
        color="primary"
        diameter="75"
      >
      </mat-spinner>
      <span> {{ tdsAuthed ? 'Authorising Transaction' : 'Confirming 3D Secure Status'}}</span>
    </div>
  </div>